import { postAudit } from "../services/audit/audit";

export const registerAudit = async (body:any) => {
    try {
        await postAudit(body);
    } catch (error) {
        console.error(error);
    }
    return;
}